var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w3-button w3-text-theme",staticStyle:{"margin":"0px","padding":"0px"},attrs:{"type":"button"},on:{"click":function($event){_vm.$emit(_vm.action)}}},[_c('font-awesome-icon',{attrs:{"icon":[_vm.type, _vm.icon]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }